
const Loader = () => {
    return(
        <div className={"loading-spinner"}>
            <div className={"loading-spinner_loader"}>
            </div>
            <img src="https://enigoo.cz/front-module/img/enigoo-purple.svg" alt="Engioo"/>
        </div>
    )
}
export default Loader
